import React, { Component } from 'react'
import { Colxx } from '../../components/custom-bootstrap'
import { Button, Card, FormGroup, Label, Row } from 'reactstrap'
import { NavLink } from 'react-router-dom'
import Select from 'react-select'
import { CustomSelectInput } from '../../components/custom-select-input'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { FormikCustomRadioGroup, FormikDatePicker, FormikReactSelect } from '../../components/formik-fields'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { selectProvinceIsLoading, selectProvinceItemsMapped } from '../../redux/province/selector'
import { selectDistrictIsLoading, selectDistrictItemsMapped } from '../../redux/district/selector'
import { selectBranchIsLoading, selectBranchItemsMapped } from '../../redux/branch/selector'
import { selectAuthUserError, selectAuthUserIsLoading, selectAuthUserMessage } from '../../redux/auth/selector'
import { getProvinceStart } from '../../redux/province/actions'
import { getDistrictStart } from '../../redux/district/actions'
import { getBranchStart } from '../../redux/branch/actions'
import { registerUser } from '../../redux/auth/actions'

const genderData = [
  { value: 'MALE', label: 'Nam' },
  { value: 'FEMALE', label: 'Nữ' },
  { value: 'OTHER', label: 'Khác' },
]

const Schema = Yup.object().shape({
  name: Yup.string().min(4, 'Tên đầy đủ phải lớn hơn 4 kí tự').required('Vui lòng nhập tên đầy đủ'),
  email: Yup.string().email('Địa chỉ email không hợp lệ').required('Vui lòng nhập địa chỉ email'),
  password: Yup.string().min(6, 'Mật khẩu phải lớn hơn 6 kí tự').required('Vui lòng nhập mật khẩu'),
  phone: Yup.string()
    .matches(/^\d{10}$/, 'Số điện thoại không hợp hệ')
    .required('Vui lòng nhập số điện thoại'),
  gender: Yup.string().required('Vui lòng chọn giới tính'),
  address: Yup.string().required('Vui lòng nhập địa chỉ'),
  province: Yup.string().ensure().required('Vui lòng chọn thành phố'),
  district: Yup.string().ensure().required('Vui lòng chọn quận / huyện'),
  branch: Yup.string().ensure().required('Vui lòng chọn kho nhận hàng'),
})

class Register extends Component {
  componentDidMount() {
    this.props.getProvinceStart()
    this.props.getBranchStart()
  }

  handleCustomerRegister = (values) => {
    const payload = {
      ...values,
      province: values.province.value,
      district: values.district.value,
      branch: values.branch.value,
    }
    this.props.registerCustomer(payload, this.props.history)
  }

  render() {
    const {
      isProvinceLoading,
      isDistrictLoading,
      isBranchLoading,
      provinceItems,
      districtItems,
      branchItems,
      isRegisterUserLoading,
    } = this.props

    return (
      <Row className="h-100">
        <Colxx xxs="12" md="10" className="mx-auto my-auto">
          <Card className="auth-card">
            <div className="position-relative image-side ">
              <p className="text-white h2">Đăng Ký</p>
              <p className="white mb-0">
                Vui lòng sử dụng mẫu bên cạnh để đăng ký. <br />
                Nếu bạn là khách hàng, vui lòng{' '}
                <NavLink to={`/login`} className="white">
                  đăng nhập
                </NavLink>
                .
              </p>
            </div>
            <div className="form-side">
              <Formik
                initialValues={{
                  name: '',
                  email: '',
                  password: '',
                  phone: '',
                  gender: 'MALE',
                  dob: null,
                  address: '',
                  province: '',
                  district: '',
                  branch: '',
                }}
                onSubmit={this.handleCustomerRegister}
                validationSchema={Schema}
              >
                {({ setFieldValue, setFieldTouched, values, errors, touched }) => (
                  <Form className="av-tooltip" autoComplete="off">
                    <FormGroup className="tooltip-right-top">
                      <Label>Tên đầy đủ</Label>
                      <Field className="form-control" name="name" />
                      {errors.name && touched.name ? (
                        <div className="invalid-feedback d-block">{errors.name}</div>
                      ) : null}
                    </FormGroup>

                    <FormGroup className="tooltip-right-top">
                      <Label>E-Mail</Label>
                      <Field className="form-control" name="email" />
                      {errors.email && touched.email ? (
                        <div className="invalid-feedback d-block">{errors.email}</div>
                      ) : null}
                    </FormGroup>

                    <FormGroup className="tooltip-right-top">
                      <Label>Mật khẩu</Label>
                      <Field className="form-control" type="password" name="password" />
                      {errors.password && touched.password ? (
                        <div className="invalid-feedback d-block">{errors.password}</div>
                      ) : null}
                    </FormGroup>

                    <FormGroup className="tooltip-right-top">
                      <Label>Số điện thoại</Label>
                      <Field className="form-control" name="phone" />
                      {errors.phone && touched.phone ? (
                        <div className="invalid-feedback d-block">{errors.phone}</div>
                      ) : null}
                    </FormGroup>

                    <FormGroup>
                      <Label>Ngày sinh</Label>
                      <FormikDatePicker
                        name="dob"
                        value={values.dob}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                      />
                    </FormGroup>

                    <FormGroup className="tooltip-right-top">
                      <Label>Địa chỉ</Label>
                      <Field className="form-control" name="address" />
                      {errors.address && touched.address ? (
                        <div className="invalid-feedback d-block">{errors.address}</div>
                      ) : null}
                    </FormGroup>

                    <FormGroup className="tooltip-right-top">
                      <Label>Chọn tỉnh / thành phố</Label>
                      <Select
                        components={{
                          Input: CustomSelectInput,
                        }}
                        className="react-select"
                        classNamePrefix="react-select"
                        name="province"
                        value={values.province}
                        isDisabled={isProvinceLoading}
                        isLoading={isProvinceLoading}
                        isMulti={false}
                        isSearchable={true}
                        placeholder="Tỉnh - thành phố"
                        onChange={(selectedOption) => {
                          setFieldValue('province', selectedOption)
                          const { value } = selectedOption
                          this.props.getDistrictStart(value)
                          setFieldValue('district', '')
                          setFieldTouched('district', false)
                        }}
                        onBlur={() => {
                          setFieldTouched('province', true)
                        }}
                        options={provinceItems}
                      />
                      {errors.province && touched.province ? (
                        <div className="invalid-feedback d-block">{errors.province}</div>
                      ) : null}
                    </FormGroup>

                    <FormGroup className="tooltip-right-top">
                      <Label>Chọn quận / huyện</Label>
                      <FormikReactSelect
                        name="district"
                        value={values.district}
                        isDisabled={isDistrictLoading}
                        isLoading={isDistrictLoading}
                        isMulti={false}
                        isSearchable={true}
                        placeholder="Quận - huyện"
                        options={districtItems}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                      />
                      {errors.district && touched.district ? (
                        <div className="invalid-feedback d-block">{errors.district}</div>
                      ) : null}
                    </FormGroup>

                    <FormGroup className="tooltip-right-top">
                      <Label>Chọn chi nhánh nhận hàng</Label>
                      <FormikReactSelect
                        name="branch"
                        value={values.branch}
                        isDisabled={isBranchLoading}
                        isLoading={isBranchLoading}
                        isMulti={false}
                        isSearchable={true}
                        placeholder="Chi nhánh nhận hàng"
                        options={branchItems}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                      />
                      {errors.branch && touched.branch ? (
                        <div className="invalid-feedback d-block">{errors.branch}</div>
                      ) : null}
                    </FormGroup>

                    <FormGroup className="tooltip-right-top">
                      <Label className="d-block">Giới tính</Label>
                      <FormikCustomRadioGroup
                        inline
                        name="gender"
                        id="customRadioGroup"
                        label="Which of these?"
                        value={values.gender}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        options={genderData}
                      />
                      {errors.gender && touched.gender ? (
                        <div className="invalid-feedback d-block">{errors.gender}</div>
                      ) : null}
                    </FormGroup>

                    <div className="d-flex justify-content-end align-items-center">
                      <Button
                        type="submit"
                        color="primary"
                        className={`btn-shadow btn-multiple-state ${isRegisterUserLoading ? 'show-spinner' : ''}`}
                        size="lg"
                      >
                        <span className="spinner d-inline-block">
                          <span className="bounce1" />
                          <span className="bounce2" />
                          <span className="bounce3" />
                        </span>
                        <span className="label">Đăng Ký</span>
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </Card>
        </Colxx>
      </Row>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  isProvinceLoading: selectProvinceIsLoading,
  provinceItems: selectProvinceItemsMapped,
  isDistrictLoading: selectDistrictIsLoading,
  districtItems: selectDistrictItemsMapped,
  isBranchLoading: selectBranchIsLoading,
  branchItems: selectBranchItemsMapped,
  isRegisterUserLoading: selectAuthUserIsLoading,
  userRegisterMessage: selectAuthUserMessage,
  userRegisterError: selectAuthUserError,
})

const mapDispatchToProps = (dispatch) => ({
  getProvinceStart: () => dispatch(getProvinceStart()),
  getDistrictStart: (id) => dispatch(getDistrictStart(id)),
  getBranchStart: () => dispatch(getBranchStart()),
  registerCustomer: (user, history) => dispatch(registerUser(user, history)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Register)
